import { render, staticRenderFns } from "./StockItemRecurring.vue?vue&type=template&id=0a576fd5&"
import script from "./StockItemRecurring.vue?vue&type=script&lang=js&"
export * from "./StockItemRecurring.vue?vue&type=script&lang=js&"
import style0 from "./StockItemRecurring.vue?vue&type=style&index=0&id=0a576fd5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports